<button mat-raised-button (click)="save()" [disabled]="isDisabled"
        class="save-button__button
            w-100
            d-flex
          align-items-center justify-content-center"
        color="primary">
    <mat-icon>arrow_right</mat-icon>
    <span>{{title|translate}}</span>
</button>
